import React, { Suspense, lazy, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track, trackPageView, initAnalytics } from "./lib/analytics";

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => { trackPageView(location.pathname); }, [location.pathname]);
  return null;
}
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import { ThemeProvider } from "./lib/theme";
import Layout from "./components/Layout";
import { Loader } from "./components/ui-kit";
import FeedbackPopup from "./components/FeedbackPopup";
import Onboarding from "./pages/Onboarding";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import DownloadGurSetuPage from "./pages/DownloadGurSetuPage";

// Existing pages
const Home = lazy(() => import("./pages/Home"));
const Hukamnama = lazy(() => import("./pages/Hukamnama"));
const HukamnamaReader = lazy(() => import("./pages/HukamnamaReader"));
const Nitnem = lazy(() => import("./pages/Nitnem"));
const NitnemReader = lazy(() => import("./pages/NitnemReader"));
const Simran = lazy(() => import("./pages/Simran"));
const Calendar = lazy(() => import("./pages/Calendar"));
const Events = lazy(() => import("./pages/Events"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Kids = lazy(() => import("./pages/Kids"));
const Quest = lazy(() => import("./pages/Quest"));
const DailyQuiz = lazy(() => import("./pages/DailyQuiz"));
const Yatra = lazy(() => import("./pages/Yatra"));
const YatraDetail = lazy(() => import("./pages/YatraDetail"));
// ❌ DELETE THIS LINE:
// const Inspiration = lazy(() => import("./pages/Inspiration"));
const HukamJournal = lazy(() => import("./pages/HukamJournal"));
const Bookmarks = lazy(() => import("./pages/Bookmarks"));
const AISahayak = lazy(() => import("./pages/AISahayak"));
const Reflection = lazy(() => import("./pages/Reflection"));
const ReflectionMemories = lazy(() => import("./pages/ReflectionMemories"));
const AdminReflections = lazy(() => import("./pages/admin/AdminReflections"));
const LiveKirtan = lazy(() => import("./pages/LiveKirtan"));
const Settings = lazy(() => import("./pages/Settings"));
const About = lazy(() => import("./pages/About"));
const Notifications = lazy(() => import("./pages/Notifications"));
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const NotFound = lazy(() => import("./pages/NotFound"));

// ✨ NEW: Premium Inspiration Feature Routes
const InspirationMain = lazy(() => import("./inspiration/index"));
const InspirationDetail = lazy(() => import("./inspiration/detail"));
const InspirationSaved = lazy(() => import("./inspiration/saved"));

export default function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <Toaster position="top-center" theme="dark" richColors closeButton />
          <Suspense fallback={<div className="min-h-screen grid place-items-center bg-app"><Loader /></div>}>
            <Routes>
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/reflections" element={<AdminReflections />} />
              <Route path="/*" element={
                <Layout>
                  <Suspense fallback={<Loader />}>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/hukamnama" element={<Hukamnama />} />
                      <Route path="/hukamnama/reader" element={<HukamnamaReader />} />
                      <Route path="/nitnem" element={<Nitnem />} />
                      <Route path="/nitnem/:baniId" element={<NitnemReader />} />
                      <Route path="/simran" element={<Simran />} />
                      <Route path="/calendar" element={<Calendar />} />
                      <Route path="/events" element={<Events />} />
                      <Route path="/gallery" element={<Gallery />} />
                      <Route path="/kids" element={<Kids />} />
                      <Route path="/quest" element={<Quest />} />
                      <Route path="/quiz" element={<DailyQuiz />} />
                      <Route path="/yatra" element={<Yatra />} />
                      <Route path="/yatra/:slug" element={<YatraDetail />} />
                      
                      {/* ✨ NEW: Premium Inspiration Routes */}
                      <Route path="/inspiration" element={<InspirationMain />} />
                      <Route path="/inspiration/detail" element={<InspirationDetail />} />
                      <Route path="/inspiration/saved" element={<InspirationSaved />} />
                      
                      <Route path="/hukam-journal" element={<HukamJournal />} />
                      <Route path="/bookmarks" element={<Bookmarks />} />
                      <Route path="/ai" element={<AISahayak />} />
                      <Route path="/reflection" element={<Reflection />} />
                      <Route path="/kirtan" element={<LiveKirtan />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/settings/reflection-memories" element={<ReflectionMemories />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/privacy" element={<PrivacyPolicy />} />
<Route path="/terms" element={<TermsOfUse />} />   
                      <Route path="/notifications" element={<Notifications />} />
                      <Route path="/get-gursetu" element={<DownloadGurSetuPage />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </Suspense>
                  <FeedbackPopup />
                </Layout>
              } />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </I18nProvider>
    </ThemeProvider>
  );
}